import {computed, defineComponent, PropType} from 'vue';
import * as KlipApi from '@/api/klip-api.proxy';
import {OrderDirection} from '@/api/klip-api.proxy';
import {useVModel} from '@vueuse/core';

export default defineComponent({
    name: 'KlCardSort',
    emits: ['update:modelValue', 'toggleSortOrder'],
    props: {
        modelValue: {
            type: String,
            required: false,
            default: '',
        },
        columns: {
            type: Array as () => KlipApi.IColumn[],
            required: false,
            default: () => [],
        },
    },
    setup(props, { emit }) {

        const currentSortedColumnKey = useVModel(props, 'modelValue', emit);

        const currentSortedColumn = computed((): KlipApi.IColumn => {
            return props.columns?.find((cc) => cc.key === currentSortedColumnKey.value);
        });

        const currentSortedColumnIcon = computed((): string => {
            if (!currentSortedColumn.value) {
                return '';
            }
            const directionIcon = currentSortedColumn.value.type === "Number"
                ? "arrange-" + (currentSortedColumn.value.direction === OrderDirection.Asc ? "1-to-9" : "9-to-1")
                : currentSortedColumn.value.type === "String"
                    ? "arrange-" + (currentSortedColumn.value.direction === OrderDirection.Asc ? "a-to-z" : "z-to-a")
                    : currentSortedColumn.value.direction === OrderDirection.Asc
                        ? "arrow-up"
                        : "arrow-down";

            return directionIcon;
        });

        const toggleColumnSortOrder = () => {
            const direction = currentSortedColumn.value.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc;
            //currentSortedColumn.value.direction = currentSortedColumn.value.direction === OrderDirection.Asc ? OrderDirection.Desc : OrderDirection.Asc;
            //columnClicked(currentSortedColumn.value);
            emit('toggleSortOrder', direction);
        }

        return {
            currentSortedColumnKey,
            currentSortedColumnIcon,
            toggleColumnSortOrder,
        };
    }
});
